import styled from '@emotion/styled';
import { useTranslation } from '@hotjar/translations';
import { Text, tokens } from '@hotjar/hotsauce';
import type { RecordingsData } from '@hotjar/webapp/domains/activation/featured-insights/types';

const FlowGuide = styled.div``;

const FlowPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${tokens.spacer.x2};
`;

const FlowPageRow = styled.div`
  display: flex;
  gap: 6px;
`;

const FlowPage = styled(Text)`
  padding: 2px 6px;
  background-color: ${tokens.color.bg_active};
  border-radius: 4px;
  color: #000000;
  word-break: break-all;
`;

const DOT_SIZE = tokens.spacer.x0pt5;
const DOT_MARGIN_TOP = '7px';
const FLOW_PAGE_COUNTER = tokens.spacer.x4pt5;

const FlowDot = styled.div`
  width: ${DOT_SIZE};
  min-width: ${DOT_SIZE};
  height: ${DOT_SIZE};
  margin-top: ${DOT_MARGIN_TOP};
  background-color: ${tokens.color.text_disabled};
  border-radius: ${DOT_SIZE};
`;

const FlowLine = styled(FlowDot)`
  width: ${DOT_SIZE};
  height: calc(100% + calc(${FLOW_PAGE_COUNTER} - 20px));
  margin: 8px 0 0;
`;

const FlowPageCounter = styled.div`
  display: flex;
  align-items: center;
  height: ${FLOW_PAGE_COUNTER};
  margin-left: 10px;
`;

type RecordingSidebarFlowGuideProps = {
  exitPageUrl: RecordingsData['exitPageUrl'];
  landingPageUrl: RecordingsData['landingPageUrl'];
  pageCount: RecordingsData['pageCount'];
};

export const RecordingSidebarFlowGuide = ({
  flow,
}: {
  flow: RecordingSidebarFlowGuideProps;
}): JSX.Element => {
  const { t } = useTranslation();
  const { landingPageUrl, pageCount, exitPageUrl } = flow;

  return (
    <FlowGuide>
      <FlowPageContainer>
        <FlowPageRow>
          <div>
            <FlowDot />
            <FlowLine />
          </div>
          <FlowPage textType="caption">{landingPageUrl}</FlowPage>
        </FlowPageRow>
        <FlowPageRow>
          <FlowPageCounter>
            {t('activation:space-overview.for-you.featured-insights.slider.slide.recording.pages', {
              count: pageCount,
            })}
          </FlowPageCounter>
        </FlowPageRow>
        <FlowPageRow>
          <FlowDot />
          <FlowPage textType="caption">{exitPageUrl}</FlowPage>
        </FlowPageRow>
      </FlowPageContainer>
    </FlowGuide>
  );
};
